module.exports = __webpack_public_path__ + "img/0002.fdfc4d14.jpg";